import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { ACTIVITIES_BASE_URL } from '~/core/core.module';
import { PromoCodeInterface } from '~/checkout/components/pages/payment/promo-code/payment-promo-code.interface';
import { CheckoutService } from '~/checkout/services/checkout/checkout.service';
import { APP_STORAGE } from '~/app.token';

const PROMO_CODE_STORAGE_KEY = 'checkout.code';

@Injectable({
  providedIn: 'root',
})
export class PromoCodeService {
  public needTotalPriceUpdateSubject = new BehaviorSubject<PromoCodeInterface>(
    null
  );

  public needToClearPromoCodeInputSubject = new BehaviorSubject<boolean>(false);

  constructor(
    protected readonly checkoutService: CheckoutService,
    protected readonly httpClient: HttpClient,
    @Inject(ACTIVITIES_BASE_URL) private readonly baseUrl: string,
    @Inject(APP_STORAGE) private readonly storage: Storage
  ) {}

  public getPromoCode(
    promoCodeData: string,
    cartContent
  ): Observable<PromoCodeInterface> {
    return this.httpClient.post<PromoCodeInterface>(
      `${this.baseUrl}/promotion`,
      {
        code: promoCodeData,
        cart: cartContent,
      }
    );
  }

  public setPromoCodeValue(promoCode: PromoCodeInterface): void {
    this.needTotalPriceUpdateSubject.next(promoCode);
    if (promoCode) {
      this.savePromoCode(promoCode);
    }
  }

  public clearInputValue(): void {
    this.needToClearPromoCodeInputSubject.next(true);
  }

  public resetClearInputValue(): void {
    this.needToClearPromoCodeInputSubject.next(false);
  }

  public getClearInputValue(): Observable<boolean> {
    return this.needToClearPromoCodeInputSubject.asObservable();
  }

  public getPromoCodeValue(): Observable<PromoCodeInterface> {
    return this.needTotalPriceUpdateSubject.asObservable();
  }

  public savePromoCode(code): void {
    this.storage.setItem(PROMO_CODE_STORAGE_KEY, JSON.stringify(code));
  }

  public loadPromoCode(): string {
    return this.storage.getItem(PROMO_CODE_STORAGE_KEY);
  }

  public clearPromoCode(): void {
    this.storage.removeItem(PROMO_CODE_STORAGE_KEY);
  }
}
